module.exports = __webpack_public_path__ + "img/fall_detection.de51306b.png";